import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-domain-config-section",
  templateUrl: "./domain-config-section.component.html",
  styleUrls: ["./domain-config-section.component.scss"],
})
export class DomainConfigSectionComponent implements OnInit {
  domainForm: FormGroup;
  // modifiedby = 'Admin'; // Example value
  // modifieddate = new Date();
  mode = "new";
  domainsettingsectionid: string;
  doaminSettingsection: any;
  guid: GUID;
  isLoading = false;
  isError = false;
  errorMessage = "";
  domainid: string;
  domainkey: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastService,
    private dataService: DataService
  ) {
    this.domainForm = this.fb.group({
      name: ["", Validators.required],
      label: ["", Validators.required],
      sortorder: ["", Validators.required],
      description: [""],
      // active: [false]
    });
  }

  //   ngOnInit(){
  //     this.guid = new GUID();

  // this.route.queryParams.subscribe((params) => {

  //       this.mode = this.route.snapshot.params.mode;

  //       this.domainsettingsectionid = this.route.snapshot.params.id;

  //   this.mode = params['mode'] || 'new';
  //       this.domainkey = params['domainkey'];

  //       this.domainid = params['id']; // example: D000000UHG8Q
  //       this.domainsettingsectionid = params['id'];

  //     });
  //       if (this.mode.toLowerCase() == "edit") {
  //     this.getDomainsettingsectionedit();
  //   }
  //   }

  ngOnInit() {
    this.guid = new GUID();

    this.route.params.subscribe((params) => {
      this.mode = params["mode"] || "new";
      this.domainkey = params["domainkey"]; // 'Account'
      this.domainid = params["domainid"]; // 'D000000UHG8Q'
      this.domainsettingsectionid = params["id"];

      console.log("Domain ID:", this.domainid); // ✅ should print D000000UHG8Q
      console.log("Domain Key:", this.domainkey); // ✅ should print Account
      if (this.mode.toLowerCase() === "edit") {
        this.getDomainsettingsectionedit();
      }
    });

    this.domainForm.get("name").valueChanges.subscribe((val) => {
      if (val && val.includes(" ")) {
        this.domainForm.get("name").setValue(val.replace(/\s+/g, ""), {
          emitEvent: false,
        });
      }
    });
  }

  removeSpaces(event: ClipboardEvent) {
    let paste = event.clipboardData.getData("text") || "";
    paste = paste.replace(/\s+/g, ""); // remove all spaces

    event.preventDefault();
    this.domainForm.get("name").setValue(paste);
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  cancel() {
    this.router.navigateByUrl(
      `home/domainsectionlist/${this.domainkey}/${this.domainid}`
    );
    // this.router.navigateByUrl("home/domainsettinglist");
  }

  // cancel(domainkey?: string, elementId?: string): void {
  //   if (domainkey && elementId) {
  //     this.router.navigate(['home', 'domainsectionlist', domainkey, elementId]);
  //   } else {
  //     this.router.navigate(['home', 'domainsectionlist']);
  //   }
  // }

  save() {
    if (this.domainForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("name is mandatory");
      return;
    }
    if (this.domainForm.controls["label"].value.toString().trim() == "") {
      this.showWarning("label is mandatory");
      return;
    }
    if (this.domainForm.controls["sortorder"].value == "") {
      this.showWarning("sortorder is mandatory");
      return;
    }

    //  if (this.domainForm.controls["description"].value.toString().trim() == "") {
    //       // this.showWarning("Name is description");
    //       return;
    //   }

    if (this.mode.toLowerCase() == "new") {
      this.domainsettingsectionid = this.guid.getGUID("domainsettingsection");
    }

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),

      data: {
        domainsettingsection: {
          id: this.domainsettingsectionid,
          metaapplicationid: localStorage.getItem("crm_metaapplicationid"),
          domainid: this.domainid,
          mode: this.mode,
          name: this.domainForm.controls["name"].value.trim(),
          label: this.domainForm.controls["label"].value.trim(),
          sortOrder: this.domainForm.controls["sortorder"].value,
          description: this.domainForm.controls["description"].value.trim(),
          // active: this.domainForm.controls["active"].value
        },
      },
    };
    console.log("Domain ID being sent:", this.domainid);
    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertDomainSettingSection(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          // this.router.navigateByUrl("home/domainsection");
          this.router.navigateByUrl(
            `home/domainsectionlist/${this.domainkey}/${this.domainid}`
          );
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  getDomainsettingsectionedit() {
    return new Promise((resolve, reject) => {
      console.log("getcrudmessages");

      // alert(id)
      const id = this.domainsettingsectionid;
      const organizationid = localStorage.getItem("crm_orgid");

      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getDomainsettingSectionById(domain, subdomain, organizationid, id)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.doaminSettingsection = res.data.domainsettingsection[0];
              console.log("Doneeee****", this.doaminSettingsection);

              if (this.doaminSettingsection != null) {
                this.domainForm.controls["name"].setValue(
                  this.doaminSettingsection.name
                );
                this.domainForm.controls["label"].setValue(
                  this.doaminSettingsection.label
                );
                this.domainForm.controls["sortorder"].setValue(
                  this.doaminSettingsection.sortorder
                );

                this.domainForm.controls["description"].setValue(
                  this.doaminSettingsection.description
                );

                // this.domainForm.controls["active"].setValue(
                //   this.doaminSettingsection.active
                // );
                // if (this.doaminSettingsection.organizationid != null) {
                //   this.domainForm.controls["type"].setValue("tenant");
                // } else {
                //   this.domainForm.controls["type"].setValue("common");
                // }
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  // getDomainsettingSectionById() {
  //     return new Promise((resolve, reject) => {
  //       console.log("getcrudmessages");

  //       // alert(id)
  //       const id = this.domainsettingsectionid;
  //       const organizationid = localStorage.getItem("crm_orgid");

  //       // const domain = localStorage.getItem("domain");
  //       // const subdomain = localStorage.getItem("subdomain");
  //       const domain = localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.domain`
  //       );
  //       const subdomain = localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.subdomain`
  //       );
  //       this.isLoading = true;
  //       this.dataService.getDomainsettingById(domain, subdomain, organizationid,id).subscribe(
  //         (res) => {
  //           console.log("res", res);

  //           if (res.success == 1) {
  //             this.doaminSettingsection = res.data.doaminSettingsection[0];
  //             console.log("Doneeee****", this.doaminSettingsection);

  //             if (this.doaminSettingsection != null) {
  //               // this.dataSource = this.crudmessages.map((item) => ({
  //               //   id: item.id,
  //               //   // label: item.label,
  //               //   message: item.message,
  //               //   operation: item.operation.charAt(0).toUpperCase() + item.operation.slice(1),
  //               //   language: item.languagecode,
  //               //   // modifiedby: item.modifiedby,
  //               //   // modifieddate: item.modifieddate,
  //               //   // type: item.organizationid,
  //               //   // type: item.organizationid ? item.organizationid : 'common',
  //               //   type: item.organizationid ? 'Tenant' : 'Common',
  //               //   // content: item.content,
  //               //   // metalayoutid: item.metalayoutid,
  //               // }));
  //               this.domainForm.controls["name"].setValue(
  //                 this.doaminSettingsection.domainkey
  //               );
  //               this.domainForm.controls["label"].setValue(
  //                 this.doaminSettingsection.label
  //               );
  //               this.domainForm.controls["sortorder"].setValue(
  //                 this.doaminSettingsection.sortorder
  //               );

  //               this.domainForm.controls["description"].setValue(
  //                 this.doaminSettingsection.description
  //               );

  //               this.domainForm.controls["active"].setValue(
  //                 this.doaminSettingsection.active
  //               );
  //               // if (this.domainSetting.organizationid != null) {
  //               //   this.domainForm.controls["type"].setValue("tenant");
  //               // } else {
  //               //   this.domainForm.controls["type"].setValue("common");
  //               // }
  //             }

  //             this.isLoading = false;
  //           } else {
  //             console.log("Error while saving");
  //             this.isLoading = false;
  //           }
  //         },
  //         (err) => {
  //           console.log("Error***:", err);
  //           this.errorMessage = err.message;
  //           this.isError = true;
  //           this.isLoading = false;
  //           resolve(null);
  //         }
  //       );
  //     });
  //   }
}
